import createVueApp from '@/common/create_app'

Styxie.Initializers.StatsReports = {
  show: async(props) => {
    const { default: ReportShow } = await import('@/vue_widgets/reports/show/index.vue')
    createVueApp(ReportShow, { props: { statsProps: props } })
  }
}
